import React, { useEffect } from "react";
import { ConfigProvider, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";

import Sidebar from "layout/Sidebar";
import RoutesComponents from "routes";

import ZoomControl from "components/ZoomControl";
import ErrorHandler from "components/ErrorHandler";

import { AppContainer, MainViewContainer, SVGDownBackGround } from "App.styled";

Spin.setDefaultIndicator(<LoadingOutlined />);

const App: React.FC = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "/spa/neft-settlement") {
      navigate("generation");
    }
  }, [location.pathname, navigate]);

  return (
    <ConfigProvider>
      <ZoomControl />
      <AppContainer hasSider={true}>
        <Sidebar />
        <ErrorHandler>
          <MainViewContainer>
            <SVGDownBackGround
              width="306"
              height="347"
              viewBox="0 0 306 347"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <ellipse
                opacity="0.5"
                cx="192.5"
                cy="192.257"
                rx="192.5"
                ry="191.723"
                fill="#E9F6FE"
              />
            </SVGDownBackGround>
            <RoutesComponents />
          </MainViewContainer>
        </ErrorHandler>
      </AppContainer>
    </ConfigProvider>
  );
};

export default App;
